import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { DEFAULT_LANGUAGE } from './config/api';
import enTranslations from './locales/en.json';
import srTranslations from './locales/sr.json';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: enTranslations
      },
      sr: {
        translation: srTranslations
      }
    },
    lng: DEFAULT_LANGUAGE, // default language from environment
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false // React already handles escaping
    }
  });

export default i18n;
